export default {
  NewAppVertionAdd: 'New AppVersion Add',
  UpdateAppVertion: 'Update App Vertion',
  AppVerstionRemoved: 'App Verstion Removed',
  UpdateVariable: 'Update Variable',

  Application: 'Application',
  AppType: 'App Type',
  Enable: 'Enable',
  Download: 'Download',
  Code: 'Code',
  Description: 'Description',
  ForceDownload: 'Force Download',
  ReleaseTime: 'Release Time',
  ReleaseTimeMin: 'Release Time Min',
  ReleaseTimeMax: 'Release Time Max',
  Version: 'Version',
  Variable: 'variable',
  Value: 'Value',
  Variabletype: 'Variable Type',
  Stable: 'Stable',
  Features: 'Features',
  uploadedIn: 'Uploaded in',
  playStore: 'Play store',
  cafeBazaar: 'Cafe bazaar',
  myket: 'Myket',
  typeTitle: 'Type title',
  referenceId: 'Reference id',
  externalSystemTitle: 'External system title',
  externalCode: 'External code',
  missType: 'Miss type',
  notSupported: 'Not supported',
  addToDictionary: 'Add to dictionary',
  internalSystemTitle: 'Internal system',
  dictionaryBased: 'Dictionary based',
  sendMethod: 'Send method',
  token: 'Token',
  tokenBased: 'Token Based',
  editProfile: 'Edit profile',

  //
  loginViaOtp: 'Login Via OTP',
  confirmEmailRequired: 'Confirm email required',
  confirmMobileRequired: 'Confirm mobile required',
  loginViaEmail: 'Login Via email',
  loginViaSms: 'Login via sms',
  twoFactorEnabled: 'Two factor enabled',
  confirm: 'Confirm',

  //
  registerByOtp: 'Register by OTP',
  required: 'Required',

  // security
  lengthMin: 'Length min',
  lengthMax: 'Length max',
  character: 'Character',
  lowerCase: 'Lowercase',
  upperCase: 'Uppercase',
  specialCharacter: 'Special character',
  number: 'Number',
  jwt: 'jwt',
  minute: 'Minute',
  second: 'Second',
  accessTokenWebExpireMinute: 'Access token web expire minute',
  accessTokenAndroidExpireMinute: 'Access token app expire minute',
  refreshTokenAndroidExpireMinute: 'Refresh token app expire minute',
  refreshTokenWebExpireMinute: 'Refresh token web expire minute',
  accessTokenWebAdminExpireMinute: 'Access token web admin expire minute',
  refreshTokenWebAdminExpireMinute: 'Refresh token web admin expire minute',
  accessTokenWebCompanyExpireMinute: 'Access token web courier expire minute',
  refreshTokenWebCompanyExpireMinute: 'Refresh token web admin expire minute',
  accessTokenAndroidAdminExpireMinute:
    'Access token app admin panel expire minute',
  refreshTokenAndroidAdminExpireMinute:
    'Refresh token app admin panel expire minute',
  accessTokenAndroidCourierExpireMinute:
    'Access token app courier panel expire minute',
  refreshTokenAndroidCourierExpireMinute:
    'Refresh token app courier panel expire minute',
  accessTokenAndroidDriverExpireMinute: 'Access token app driver expire minute',
  refreshTokenAndroidDriverExpireMinute:
    'Refresh token app driver expire minute',
  lock: 'lock',
  time: 'time',
  accessFailedLimit: 'Access failed limit',
  accessFailedCritical: 'Access failed critical',
  durationMinute: 'Duration minute',

  // order
  draftExpireMinute: 'Draft expire minute',
  minOrderIntervalFromCancelMinute: 'Min order interval from cancel minute',
  minOrderIntervalFromRequestMinute: 'Min order interval from request minute',
  priceExpireMinute: 'Price expire minute',
  publishIntervalSecond: 'Publish interval second',
  publishBranchIntervalSecond: 'Publish branch interval second',
  publishAreaSequence: 'Publish area sequence',

  cargo: 'Cargo',
  furniture: 'Furniture',
  postage: 'Postage',
  delivery: 'Delivery',
  pickup: 'Pickup',
  material: 'Material',
  trash: 'Trash',

  // driver
  maxNonExpireMinute: 'Maximum time to view the position of active drivers',
  maxOfflineMinute:
    'Maximum time to send the last position by the active driver',
  minInitiateMinute: 'Minimum driver load start time',

  download: 'Download',
  basePackage: 'basePackage',
  bucket: 'Bucket',
  container: 'container',
  name: 'Name',
  group: 'Group',
  moduleName: 'Module name',
  restBaseUrl: 'restBaseUrl',
  maxLength: 'Max length',
  fields: 'Fields',
  test: 'test',
  admin: 'Admin',
  minimumSdk: 'minimum SDK',

  //general
  newNumber: 'new number',
  adminNumber: "admin's numbers",
  numberExist: 'The entered number is exist',
  settingsUpdated: 'Admin numbers have been updated',

  //webService
  service: 'service',
  atLeastOneRequired: 'at least one service and operation is required',
  serviceAndOperationExist: 'service and operation is exist',
  containerIsRequired: 'container is required',
  containerAndBucketIsRequired: 'container and bucket is required',
  privateKey: 'Private key',
  smtpUrl: 'SMTP url',
  authorization: 'Authorization',
  connectionInfo: 'Connection info',
  userNamePassword: 'User name and password',
  authorizationType: 'Authorization Types',
  monitor: 'Monitor',
  shipper: 'Shipper',
  public: 'Public',
  curator: 'Curator'
}
